import { optionTitle_accounts, optionSearch_accounts } from './AccountsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AccountsOption: LazyOption = createLazyOption(
    {
        key: 'multiAccounts',
        titleStringKey: optionTitle_accounts,
        searchTermsStringKey: optionSearch_accounts,
        isHidden: () => {
            return !isFeatureEnabled('cal-multiAccounts');
        },
    },
    lazyFullModule,
    m => m.default
);
export default AccountsOption;
